import { useSearchParams } from 'react-router-dom';
import { Tabs } from '@/design-system';
import { PlatformSettingsSection } from './PlatformSettingsSection';
import { BrandingSection } from './BrandingSection';

export function GeneralSection() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'appearance' ? 'appearance' : 'platform';
  return <div className="space-y-6">
    <header><h2 className="text-xl font-semibold text-gray-900">Geral</h2>
      <p className="mt-1 text-sm text-gray-500">Configurações da plataforma e personalização visual.</p></header>
    <Tabs label="Configurações gerais" value={tab} onChange={(value) => setParams({ tab: value }, { replace: true })}
      tabs={[
        { value: 'platform', label: 'Plataforma', content: <PlatformSettingsSection /> },
        { value: 'appearance', label: 'Aparência', content: <BrandingSection /> },
      ]} />
  </div>;
}
